<template>
    <div class="container-fluid" style="padding: 0px 20px 0px 20px;">
      <div class="row pt-2 text-start mb-2">
          <div class="col-6">
              <h5>
                  <span class="badge rounded-pill text-dark p-2 px-3" style="background:LightBlue">
                  <i class="fa fa-th-list" style="font-size:24px"></i> <b>&nbsp;ผลตรวจย้อนหลัง 5 ครั้งภายใน 180 วัน</b>
                  </span>
              </h5>
          </div>
          <div class="col-6">
          </div>
      </div>
      <div class="row ">
        <div class="col-sm">
            <table id="myPatTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                <thead class="text-white" style="background:Navy">
                <tr>
                    <th style="width:80px;">รหัสประจำตัว</th>
                    <th style="width:120px;">ชื่อ</th>
                    <th style="width:200px;">ที่อยู่</th>
                    <th style="width:80px;">เลขบัตรประชาชน</th>
                    <th style="width:30px;">เพศ</th>
                    <th style="width:80px;">วันเกิด</th>
                    <th style="width:40px;">อายุ</th>
                    <th style="width:80px;">โทรศัพท์</th>
                    <th style="width:80px;">Email</th>
                    <th style="width:80px;">มาตรวจล่าสุด</th>
                    <th style="width:40px;">พิมพ์</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datalists" :key="item.patid" v-bind:data-id="item.patid">
                    <td class="text-start">{{ item.PatCode }}</td>
                    <td class="text-start">{{ item.PatName }} {{ item.PatLName }} <span v-if="item.PatName2">({{item.PatName2}}{{item.PatLName2}})</span> </td>
                    <td class="text-start">{{item.Addr1}} {{item.Tambon}} {{item.Amphor}} {{item.Province}} {{item.PostCode}}</td>
                    <td class="text-start">{{ item.IDNo }}</td>
                    <td class="text-start">{{ arrSex[item.Sex] }}</td>
                    <td class="text-start">{{ item.BirthDate }}</td>
                    <td class="text-center">{{ item.AgeYears }}</td>
                    <td class="text-start">{{ item.Tel1 }}</td>
                    <td class="text-start">{{ item.Email1 }}</td>
                    <td class="text-start">{{ item.LastDocDate }}</td>
                    <td>
                      <button class="btn btn-warning btn-sm" @click="printReport(item)" id="Print">พิมพ์</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
      </div>
    </div>

    <!-- ตารางใบสั่งตรวจแบบ Master-Detail แต่ละชุดตรวจมีเทสตั้งแต่หนึ่งเทสขึ้นไป -->
    <div id="divToPrint_MasterDtl" hidden>
      <!-- <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}"> -->
      <table style="width:100%" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}">
        <thead>
          <tr class="text-start">
            <th>Test</th>
            <th>Result5</th>
            <th>Result4</th>
            <th>Result3</th>
            <th>Result2</th>
            <th>Result1</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item1 in reportGroupTest" :key="item1.TestID">
            <tr class="text-start" v-if="item1.CountItemTest>1">
              <td colspan="6"><b>{{item1.TestName}}</b></td>
            </tr>
            <tr class="text-start" v-for="item2 in filterItemsOfGroup(reportDtl,item1.TestID)" :key="item2.ItemTestID">
              <td style="width:200px;"> - {{item2.ItemTestName}}</td>
              <td style="width:80px;">{{ item2.result5 }} <br><span v-if="item2.docdateResult5"> ({{item2.docdateResult5}})</span></td>
              <td style="width:80px;">{{ item2.result4 }} <br><span v-if="item2.docdateResult4"> ({{item2.docdateResult4}})</span></td>
              <td style="width:80px;">{{ item2.result3 }} <br><span v-if="item2.docdateResult3"> ({{item2.docdateResult3}})</span></td>
              <td style="width:80px;">{{ item2.result2 }} <br><span v-if="item2.docdateResult2"> ({{item2.docdateResult2}})</span></td>
              <td style="width:80px;">{{ item2.result1 }} <br><span v-if="item2.docdateResult1"> ({{item2.docdateResult1}})</span></td>
            </tr>
          </template>
          <tr class="text-start">
            <td colspan="6">** end of report **</td>
          </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import JsBarcode from 'jsbarcode/bin/JsBarcode'

import pdfMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import htmlToPdfmake from 'html-to-pdfmake'
pdfMake.vfs = pdfFonts.pdfMake.vfs
// // ต้องระบุตามชื่อของ ไฟล์ font
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'Patient',
  components: {

  },
  data () {
    return {
      arrSex: ['', 'ชาย', 'หญิง'],
      datalists: null,
      masks: {
        input: 'YYYY-MM-DD'
      },
      reportHd: null,
      reportDtl: null,
      reportGroupTest: null
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      // MyApiClient.get('getdata/patient_all.php?C1=' + this.globalCorpID)
      MyApiClient.get('getdata/replastlab_patlist.php?C1=' + this.globalCorpID)
        .then((resp) => {
          console.log(resp.data.response)
          this.datalists = resp.data.response
          setTimeout(function () { $('#myPatTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getReportDtlData (row) {
      var self = this
      // MyApiClient.get('getdata/replastlab_where_patid.php?PatID=' + row.PatID)
      MyApiClient.get('getdata/replastlab_where_patid_test.php?PatID=' + row.PatID)
        .then((resp) => {
          // รายการ items ผลตรวจทั้งหมด
          self.reportDtl = resp.data.response
          // ========================================= //
          // คัดมาเฉพาะชื่อ TestSuit สำหรับจัดกลุ่มพิมพ์ เรียงตามชุด
          // ========================================= //
          const result = []
          const map = new Map()
          for (const item of self.reportDtl) {
            if (!map.has(item.TestID)) {
              map.set(item.TestID, true) // set any value to Map
              result.push(item)
            }
          }
          self.reportGroupTest = result
          this.$nextTick(() => self.createA4PdfForm1ToScreen())
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // A5reportDtl filter เฉพาะเทสที่อยู่ในชุดตรวจที่ส่งค่ามา paraTestID
    filterItemsOfGroup: function (items, paraTestID) {
      return items.filter(function (item) {
        return item.TestID === paraTestID
      })
    },
    getReportData (row) {
      this.reportHd = row
      // ========================================= //
      // ดึง Detail ของใบสั่งตรวจ
      // ========================================= //
      this.getReportDtlData(row)
    },
    printReport (row) {
      console.log(row)
      // ดึงข้อมูลให้เสร็จก่อนแล้วค่อยสร้างรายงาน เรียกแบบ promise
      // A5GroupTest
      //    A5reportDtl
      this.getReportData(row)
    },
    // ----------- (1) สร้าง Pdf and Preview ---------- //
    createA4PdfForm1ToScreen () {
      var PatNamePrn = this.reportHd.PatName
      var PatLNamePrn = this.reportHd.PatLName
      var PrefixNamePrn = this.reportHd.PrefixName
      // var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint_MasterDtl')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        // pageOrientation: 'landscape',
        pageMargins: [30, 130, 30, 50],
        header: {
          margin: [30, 10, 30, 10],
          table: {
            widths: [130, 170, 80, 120],
            body: [
              [
                {
                  text: this.globalCorpInfo.name,
                  bold: false,
                  fontSize: 14,
                  lineHeight: 0.5
                },
                {}, {}, {}
              ],
              [
                { text: 'รายงานประวัติการตรวจย้อนหลังภายใน 180 วัน\n Lab History 180 days past', bold: true, style: 'tableHeader', colSpan: 4, alignment: 'center', margin: [0, 0, 0, 0] },
                {}, {}, {}
              ],
              [
                { text: 'ชื่อ นามสกุล / Name', margin: [5, 0, 0, 0], bold: true, lineHeight: 0.8 },
                { text: PrefixNamePrn + PatNamePrn + ' ' + PatLNamePrn, margin: [5, 0, 0, 0], lineHeight: 0.8 },
                { text: 'อายุ / Age', margin: [5, 0, 0, 0], bold: true, lineHeight: 0.8 },
                { text: this.reportHd.AgeYears + '.' + this.reportHd.AgeMonths + '.' + this.reportHd.AgeDays + ' years', margin: [5, 0, 0, 0], lineHeight: 0.8 }
              ],
              [
                { text: 'หมายเลขบัตรประชาชน / ID card number', margin: [5, 0, 0, 0], bold: true, colSpan: 2, lineHeight: 0.8 },
                {},
                { text: this.reportHd.IDNo, margin: [5, 0, 0, 0], colSpan: 2, lineHeight: 0.8 },
                {}
              ],
              [
                { text: 'เพศ / Gender ', margin: [5, 0, 0, 0], bold: true, lineHeight: 0.8 },
                { text: this.arrSex[this.reportHd.Sex], margin: [5, 0, 0, 0], colSpan: 3, lineHeight: 0.8 },
                {},
                {}
              ]
            ]
          },
          layout: {
            defaultBorder: false
          }
        },
        footer: function (currentPage, pageCount) {
          return {
            margin: [40, 10, 40, 20],
            table: {
              // widths: [250, 250],
              widths: [125, 125, 125, 125],
              body: [
                [
                  {
                    text: ''
                  },
                  {
                    text: ''
                  },
                  {
                    text: ''
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 0, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            },
            layout: 'noBorders'
          }
        },
        content: html,
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 14
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    }
  }
}
</script>

<style>

</style>
